import React, { memo } from 'react';

import { BaseSwiper } from '@encarpkg/design';
import TooltipPopper from 'app/components/common/TooltipPopper';

import classNames from 'classnames/bind';
import styles from './InspectOuter.module.scss';

const cx = classNames.bind(styles);

function InspectOuter({ data = null }) {
	// 2개 이상의 아이콘 노출시 필요
	const posCase = {
		front_side_member_left: 'vertical',
		front_side_member_right: 'vertical',
		front_wheel_house_left: 'right',
		front_wheel_house_right: 'left',
		inside_panel_left: 'right',
		inside_panel_right: 'left',
		rear_side_member_left: 'vertical',
		rear_side_member_right: 'vertical',
		rear_wheel_house_left: 'vertical',
		rear_wheel_house_right: 'vertical',
		trunk_floor: 'vertical',
	};

	// 툴팁 레이어
	const tooltipLayer = (item) => {
		const items = item.statusTypes.filter((v) => v && v.code !== 'WC');
		return (
			<div className={cx('tooltip')}>
				<span className={cx('ttl')}>{item.type?.title}</span>
				{items.length > 2 && (
					<div className={cx('con')}>
						{items.map((icon) => (
							<span
								key={icon.code}
								className={cx('list')}
							>
								<span className={cx('icon', icon.code.toLowerCase())} />
								{icon.title.replace('교환(교체)', '교환')}
							</span>
						))}
					</div>
				)}
			</div>
		);
	};

	// 데이터 필터링 back, front
	const dataRepeat = (value) =>
		data &&
		data.filter((v) =>
			value === 'back'
				? v.attributes?.indexOf('RANK_A') !== -1 || v.attributes?.indexOf('RANK_B') !== -1 || v.attributes?.indexOf('RANK_C') !== -1
				: v.attributes?.indexOf('RANK_ONE') !== -1 || v.attributes?.indexOf('RANK_TWO') !== -1,
		);

	// 마크업 처리
	const outerElement = (value) => {
		const result = dataRepeat(value).map((item) => {
			const items = item.statusTypes.filter((v) => v && v.code !== 'WC');
			const icons =
				items.length > 2 ? (
					<>
						<span className={cx('icon', 'multi')} />
						<span className={cx('blind')}>
							{item.type.title}:{items.map((n) => ` (${n.title})`)}
						</span>
					</>
				) : (
					items
						.filter((v) => v.code !== 'WC')
						.map((icon) => (
							<span
								key={icon.code}
								className={cx('icon', icon.code.toLowerCase())}
							>
								<span className={cx('blind')}>
									{item.type.title}: ({icon.title})
								</span>
							</span>
						))
				);
			const iconArea = (
				<span
					key={item.type?.code}
					className={cx('item', item.type?.code.toLowerCase(), { two: items.length === 2 }, posCase[item.type?.code.toLowerCase()])}
				>
					<TooltipPopper
						placement="bottom"
						trigger="click"
						tooltip={tooltipLayer(item)}
						iconText="설명 자세히보기"
					>
						{icons}
					</TooltipPopper>
				</span>
			);
			return iconArea;
		});
		return result;
	};

	const swiperOptions = {
		loop: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	};

	return (
		<div className={cx('area')}>
			<div className={cx('outer')}>
				<BaseSwiper options={swiperOptions}>
					<div className={cx('scene')}>
						<div className={cx('front')}>{outerElement('front')}</div>
					</div>
					<div className={cx('scene')}>
						<div className={cx('back')}>{outerElement('back')}</div>
					</div>
				</BaseSwiper>
				<div className={cx('swiper-pagination')} />
			</div>
			<div className={cx('explan')}>
				<strong className="blind">아이콘 설명</strong>
				<span className={cx('icon', 'x')} /> 교환
				<span className={cx('icon', 'w')} /> 판금/용접
				<span className={cx('icon', 'c')} /> 부식
				<span className={cx('icon', 'a')} /> 흠집
				<span className={cx('icon', 'u')} /> 요철
				<span className={cx('icon', 't')} /> 손상
			</div>
			<p className={cx('txt')}>* 승용차 외에는 승용차에 준하여 표시</p>
		</div>
	);
}

export default memo(InspectOuter);
